import Link, { getLinkUrl, getLinkTween } from './link';
export default Link;
export { getLinkUrl, getLinkTween };
